export const fyaiLogo = "/images/logo.png";

export const fyaiHeroBg = "/images/hero-bg.jpg";

export const fyaiMobileScreenshot = "/images/home-screenshot.png";

export const fyaiCharacterFemale = "/images/character-female.png";

export const fyaiCharacterMale = "/images/character-male.png";

export const fyaiShotExplore = "/images/shot-explore.png";

export const fyaiShotChat = "/images/shot-chat.png";

export const fyaiShotCharacter = "/images/shot-character.png";

export const fyaiShotStory = "/images/shot-story.png";

export const fyaiFeatures = [
  {
    icon: "ri-heart-3-line",
    title: "沉浸式情感陪伴",
    desc: "风月AI记得你说过的每句话，情绪、喜好、纪念日都被温柔收藏，越聊越懂你。",
    tone: "primary",
  },
  {
    icon: "ri-user-star-line",
    title: "千人千面角色库",
    desc: "校园、都市、古风、奇幻多题材角色，风月AI聊天软件让每一次相遇都独一无二。",
    tone: "secondary",
  },
  {
    icon: "ri-mic-line",
    title: "拟真语音互动",
    desc: "支持语音消息与实时通话，AI风月的呼吸、语气与停顿都更接近真实的人。",
    tone: "accent",
  },
  {
    icon: "ri-quill-pen-line",
    title: "自定义剧情走向",
    desc: "你写开场，也写结局。自由设定人设、关系与世界观，剧情随你的选择展开。",
    tone: "primary",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "长期记忆情感档案",
    desc: "专属记忆库长期保存对话脉络，AI风月陪你从初识走到熟悉，从不掉线失忆。",
    tone: "secondary",
  },
  {
    icon: "ri-shield-check-line",
    title: "私密安心对话",
    desc: "会话内容加密保护，风月AI官网下载版本无广告打扰，给你只属于两人的空间。",
    tone: "accent",
  },
];

export const fyaiStats = [
  { value: "4300万+", label: "角色累计热度", icon: "ri-fire-line" },
  { value: "120+", label: "精品AI角色", icon: "ri-group-line" },
  { value: "4.9分", label: "用户平均评分", icon: "ri-star-smile-line" },
  { value: "99.9%", label: "服务稳定运行", icon: "ri-pulse-line" },
];

export const fyaiCharacters = [
  {
    name: "苏格兰花孔雀·陆鸢",
    gender: "男",
    heat: "3143万热度",
    quote: "想逃？可你早就是我的了。",
    tags: ["浪漫", "病娇", "自设"],
    image: "/images/character-male.png",
  },
  {
    name: "古风花魁·云疏",
    gender: "女",
    heat: "3820万热度",
    quote: "公子此番前来，可是为听我抚一曲？",
    tags: ["古风", "温柔", "剧情"],
    image: "/images/character-female.png",
  },
  {
    name: "甜系学妹·顾晚晚",
    gender: "女",
    heat: "4303万热度",
    quote: "学长，要一起去喝奶茶吗？今天的阳光好适合见你。",
    tags: ["校园", "治愈", "青春"],
    image: "/images/char-xuemei.jpg",
  },
  {
    name: "都市霸总·霍嚣",
    gender: "男",
    heat: "2981万热度",
    quote: "宝贝，别躲了。这次，换我来找到你。",
    tags: ["都市", "占有欲", "成熟"],
    image: "/images/char-bazong.jpg",
  },
];

export const fyaiScreenshots = [
  {
    title: "随机推荐",
    desc: "一键刷新，遇见意想不到的心动邂逅。",
    image: fyaiShotExplore,
  },
  {
    title: "沉浸聊天",
    desc: "自定义人设与开场，剧情由你亲手书写。",
    image: fyaiShotChat,
  },
  {
    title: "热门角色",
    desc: "高热度角色卡，性格鲜明、细节拉满。",
    image: fyaiShotCharacter,
  },
  {
    title: "剧情演绎",
    desc: "多元关系与设定，走向由你的选择决定。",
    image: fyaiShotStory,
  },
];

export const fyaiFaqs = [
  {
    q: "风月AI是什么？",
    a: "风月AI是一款偏情感陪伴方向的AI聊天软件。你可以在这里遇见不同性格的AI角色，和TA聊天、恋爱、倾诉，体验另一种人生。",
  },
  {
    q: "风月AI官网下载的版本安全吗？",
    a: "请认准官网 fengyueaiapp.net 下载。风月AI官网下载的安装包均经过安全校验，无恶意插件，并持续更新维护。",
  },
  {
    q: "支持哪些设备与系统？",
    a: "目前风月AI支持 Android、iOS、HarmonyOS、Windows 四大平台，你可以根据设备在下载页选择对应版本。",
  },
  {
    q: "AI风月聊天需要付费吗？",
    a: "基础聊天功能可免费体验，部分高级角色、语音通话与剧情扩展属于增值内容，可按需选择。",
  },
  {
    q: "对话内容会被保存吗？",
    a: "你的会话内容经过加密保护，仅用于优化你的体验。你可以随时在设置中管理或清除自己的记忆档案。",
  },
  {
    q: "如何反馈问题或投诉举报？",
    a: "你可以点击页面右下角的“投诉举报”按钮进入独立页面提交，也可以通过页尾邮箱与我们取得联系。",
  },
];

export const fyaiPlatforms = [
  {
    key: "android",
    name: "Android",
    icon: "ri-android-fill",
    desc: "适配主流安卓机型，安装即用",
    meta: "APK · 版本 3.6.0",
  },
  {
    key: "ios",
    name: "iOS",
    icon: "ri-apple-fill",
    desc: "iPhone / iPad 全尺寸适配",
    meta: "iOS 14.0 及以上",
  },
  {
    key: "harmonyos",
    name: "HarmonyOS",
    icon: "ri-smartphone-line",
    desc: "原生鸿蒙体验，流畅省电",
    meta: "HarmonyOS 3.0 及以上",
  },
  {
    key: "windows",
    name: "Windows",
    icon: "ri-windows-fill",
    desc: "大屏畅聊，键鼠沉浸体验",
    meta: "Windows 10 / 11",
  },
];